import { CircularProgress } from "react-loading-indicators"

function LoadingComponent() {
    return (<div className="w-full h-fit flex items-center justify-center pt-8">
        <CircularProgress variant="bubble-dotted" color="darkGreen" size="small" />
    </div>)
}

export default LoadingComponent